import { AliquotMetaV1 } from '@csp/csp-common-hbs-model/src/lib/dto/AliquotMetaV1';
import { MetaInV1, MetaV1 } from '@csp/dmdp-api-hbs-dto';
import { Maybe } from '@csp/csp-common-model';
import { BioSampleMetaType } from '@csp/csp-common-hbs-model';

const toMetaInV1 = (data: unknown): MetaInV1 => ({
  data,
});

const toParentAliquotMetaV1 = (): AliquotMetaV1 => ({
  parent: true,
});

const getAliquotOrDefault = (metas: Maybe<MetaV1[]>): AliquotMetaV1 =>
  (metas?.find(meta => meta.type === BioSampleMetaType.ALIQUOT_V1)?.data as AliquotMetaV1) ?? { parent: false };

export const BioSampleMetaMapper = {
  toParentAliquotMetaV1,
  toMetaInV1,
  getAliquotOrDefault,
};
